/**
 * THIS FILE CONTAINS CODEGEN OUTPUT. DO NOT MODIFY MANUALLY
 *
 * Version
 * A string that consists only of decimal digits.
 */
import * as t from 'io-ts';
export const schemaId = 'Version';
export const Version = t.brand(t.string, (x) => typeof x !== 'string' || x.match(RegExp('^\\d+$', 'u')) !== null, 'Version');
export default Version;
// Success
//# sourceMappingURL=Version.js.map